import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint } from '../breakpoint';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HiddenWrapper = styled(({ above, below, print, screen, ...rest })=>/*#__PURE__*/ _jsx("div", {
        ...rest
    })).attrs({
    'data-mesh-component': 'HIDDEN'
})`
  ${({ below })=>below && css`
      /* When we are below the 'below' breakpoint: */
      ${breakpoint('xs', below)`
          display: none;
        `}
    `};

  ${({ above })=>above && css`
      /* When we are above the 'above' breakpoint: */
      ${breakpoint(above)`
          display: none;
        `}
    `};

  ${({ print })=>print && `
      @media print {
        display: none;
      }
  `};

  ${({ screen })=>screen && `
      /* Keep focus and active visuals on interactive elements */
      > :not(:focus-visible):not(:active) {
        position: absolute !important;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
        white-space: nowrap;
      }
    `};
`;
export const Hidden = ({ children, above, below, screen = false, print = false, screenReader = false, ...otherProps })=>/*#__PURE__*/ _jsx(HiddenWrapper, {
        above: above,
        below: below,
        print: print,
        screen: screen,
        "aria-hidden": screenReader,
        ...otherProps,
        children: Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child)) {
                return child;
            } else if (typeof child === 'string') {
                return /*#__PURE__*/ _jsx("span", {
                    children: child
                });
            }
            return null;
        })
    });
Hidden.displayName = 'Hidden';

//# sourceMappingURL=index.js.map